import React from 'react';
import PropTypes from 'prop-types';
import UniInputText from './UniInputText';
import UniTextarea from './UniTextarea';
import UniInputPassword from './UniInputPassword';
import UniInputNumber from './UniInputNumber';
import UniInputCheckbox from './UniInputCheckbox';
import UniSelect from './UniSelect';
import UniRadioGroup from './UniRadioGroup';
import UniBreak from './UniBreak';
import UniSeparator from './UniSeparator';
import UniText from './UniText';
import UniFieldDisplayFakeValue from './UniFieldDisplayFakeValue';
import { js_utils } from '../utils/frfr-js-utils';
import UniSpaceField from './UniSpaceField';
import UniFieldDisplayValue from './UniFieldDisplayValue';
import UniInputEmail from './UniInputEmail';
import UniWidgetStars5 from './UniWidgetStars5';
// import { reusableJqueryMoveFocus } from '../hooks/reusableJqueryMoveFocus';

const FormGenerator = (props) => {
  /*
  useEffect(() => {
    // svaki put
    // ovde cemo pozvati kod za menjanje fokusa na formama ako zatreba
    // console.log('* effect');
    // reusableJqueryMoveFocus();
  });
  */

  let arr = [];
  if (props.formDefinition) {
    if (Array.isArray(props.formDefinition)) {
      arr = props.formDefinition;
    } else if (typeof props.formDefinition === 'function') {
      const _formDefinition = props.formDefinition();
      console.log('props.formDefinition is FUNCTION...', _formDefinition);
      if (Array.isArray(_formDefinition)) {
        arr = _formDefinition;
      }
    }
  }

  let handleChange;
  if (typeof props.handleChange === 'function') {
    handleChange = props.handleChange;
  } else {
    handleChange = () => { };
  }

  let state = props.formState; // state koji sadrzi values od input polja
  let errors = {}; // state koji sadrzi greske za polja koje kreira validator forme
  if (js_utils.is_object(props.formErrors)) {
    errors = props.formErrors; // state koji sadrzi greske za polja koje kreira validator forme
  }
  let fakeState = {}; // specijalni lazni state za polja koja se samo prikazuju
  if (props.fakeState) {
    fakeState = props.fakeState;
  }

  let make_form_elements = (arr) => {
    let jsx_form_arr = arr.map((form_def_item, index) => {

      if (form_def_item && typeof form_def_item.type === 'string') {
        const fdi_type = form_def_item.type;
        if (fdi_type === "br") {
          return (
            <UniBreak key={index} />
          );
          /*
        } else if (fdi_type === "break") {
          return (
            <UniBreak key={index} />
          );
        */
        } else if (fdi_type === "separator") {
          return (
            <UniSeparator key={index} />
          );
        } else if (fdi_type === "space_field") {
          return (
            <UniSpaceField key={index} params={form_def_item.params} />
          );
        } else if (fdi_type === "row") {
          return make_form_row(form_def_item.params, index);
        } else if (fdi_type === "wrapper") {
          return make_form_group(form_def_item.params, index);
        } else if (fdi_type === "text") { // TODO single HTML tag with text
          return (
            <UniText key={index} params={form_def_item.params} />
          );
        } else if (fdi_type === "input_text") {
          return (
            <UniInputText
              key={index}
              params={form_def_item.params}
              formState={state}
              formErrors={errors}
              handleChange={handleChange}
            />
          );
        } else if (fdi_type === "input_password") {
          return (
            <UniInputPassword
              key={index}
              params={form_def_item.params}
              formState={state}
              formErrors={errors}
              handleChange={handleChange}
            />
          );
        } else if (fdi_type === "input_email") {
          return (
            <UniInputEmail
              key={index}
              params={form_def_item.params}
              formState={state}
              formErrors={errors}
              handleChange={handleChange}
            />
          );
        } else if (fdi_type === "field_display_value") { // istaknuto display (read-only) polje
          return (
            <UniFieldDisplayValue
              key={index}
              params={form_def_item.params}
              formState={state}
              formErrors={errors}
            />
          );
        } else if (fdi_type === "field_display_fake_value") {
          return (
            <UniFieldDisplayFakeValue
              key={index}
              params={form_def_item.params}
              fakeState={fakeState}
            />
          );
        } else if (fdi_type === "textarea") {
          return (
            <UniTextarea
              key={index}
              params={form_def_item.params}
              formState={state}
              formErrors={errors}
              handleChange={handleChange}
            />
          );
        } else if (fdi_type === "input_number") {
          return (
            <UniInputNumber
              key={index}
              params={form_def_item.params}
              formState={state}
              formErrors={errors}
              handleChange={handleChange}
            />
          );
        } else if (fdi_type === "input_checkbox") {
          return (
            <UniInputCheckbox
              key={index}
              params={form_def_item.params}
              formState={state}
              formErrors={errors}
              handleChange={handleChange}
            />
          );
        } else if (fdi_type === "select") {
          return (
            <UniSelect
              key={index}
              params={form_def_item.params}
              formState={state}
              formErrors={errors}
              handleChange={handleChange}
            />
          );
        } else if (fdi_type === "input_radio_group") {
          return (
            <UniRadioGroup
              key={index}
              params={form_def_item.params}
              formState={state}
              formErrors={errors}
              handleChange={handleChange}
            />
          );
        } else if (fdi_type === "widget_stars5") {
          return (
            <UniWidgetStars5
              key={index}
              params={form_def_item.params}
              formState={state}
              formErrors={errors}
              handleChange={handleChange}
            />
          );
        } else if (fdi_type === "injected_element") {
          let jsxInjected = null;
          let style = {};
          if (form_def_item.params) {
            // PRIORITY IS key_of_injected_elements_obj
            if (form_def_item.params.key_of_injected_elements_obj) { // CASE 1) obj key
              let key_of_injected = false;
              if (form_def_item.params.key_of_injected_elements_obj) {
                key_of_injected = form_def_item.params.key_of_injected_elements_obj;
                if (props.injectedElementsObj && props.injectedElementsObj[key_of_injected]) {
                  jsxInjected = props.injectedElementsObj[key_of_injected];
                }
              }
            } else { // CASE 2) arr index
              let index_of_injected = -1;
              if (form_def_item.params.index_of_injected_elements_arr === 0 || form_def_item.params.index_of_injected_elements_arr > 0) {
                index_of_injected = form_def_item.params.index_of_injected_elements_arr;
                if (Array.isArray(props.injectedElementsArr) && props.injectedElementsArr[index_of_injected]) {
                  jsxInjected = props.injectedElementsArr[index_of_injected];
                }
              }
            }
            // add style
            if (form_def_item.params.w > 0) {
              style = {
                width: form_def_item.params.w
              };
            }
          }
          /*
          if (Array.isArray(props.injectedElementsArr) && props.injectedElementsArr.length > 0) {
            if (form_def_item.params && (form_def_item.params.index_of_injected_elements_arr === 0 || form_def_item.params.index_of_injected_elements_arr > 0) && props.injectedElementsArr[form_def_item.params.index_of_injected_elements_arr]) {
            }
          }
          */
          return (
            <div className="uniformcompo__field uniformcompo__field--flex-start" key={index} style={style}>
              {jsxInjected}
            </div>
          );
        } else {
          /*
          return (
            <>
            </>
          );
          */
          return null;
        }
      } else {
        return null;
      }

    });
    return jsx_form_arr;
  };


  let make_form_row = (row_params, index) => {
    let jsx_row_elements = make_form_elements(row_params.children);
    let cl = 'IZMENIME';
    if (row_params.extraclass) {
      cl = row_params.extraclass;
    }
    let jsx_form_row = (
      <div key={index} className={"uu-form-vector-row " + cl}>
        {jsx_row_elements}
      </div>
    );
    return jsx_form_row;
  };

  let make_form_group = (row_params, index) => {
    let jsx_row_elements = make_form_elements(row_params.children);
    let cl = 'IZMENIME';
    if (row_params.extraclass) {
      cl = row_params.extraclass;
    }
    let jsx_form_row = (
      <div key={index} className={"uniformcompo__wrapper " + cl}>
        {jsx_row_elements}
      </div>
    );
    return jsx_form_row;
  };

  let jsx_form_content = make_form_elements(arr);

  let cl_validation_errors = '';
  if (js_utils.is_object(errors) && Object.keys(errors).length > 0) {
    cl_validation_errors = ' validation-errors';
  }

  let cl_extra = '';
  if (typeof props.extraclass === 'string') {
    cl_extra = ' ' + props.extraclass;
  }

  return (
    <div className={"frfr-form-generator-widget" + cl_validation_errors + cl_extra}>
      <div className="frfr-form-generator-widget__output-container">
        {jsx_form_content}
      </div>
    </div>
  );
};

FormGenerator.propTypes = {
  // formDefinition: PropTypes.array,
  formState: PropTypes.object,
  formErrors: PropTypes.object,
  handleChange: PropTypes.func
};

export default FormGenerator;